module.exports = __webpack_public_path__ + "static/img/16.13df0986.png";